import React, { useEffect, useState } from "react";
import { FaArrowDownShortWide } from "react-icons/fa6";
import { HiMiniArrowsUpDown } from "react-icons/hi2";
import data from "../../Utils/table1.json";
import copy from "clipboard-copy";
import Papa from "papaparse";
import { AiFillCaretDown } from "react-icons/ai";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "../../Style/DataTable.css";
import OutsideClickHandler from "react-outside-click-handler";
import DataTable from "react-data-table-component";
import {
  FaCopy,
  FaFileCsv,
  FaFileExcel,
  FaFilePdf,
  FaPrint,
  FaColumns,
  FaSearch,
  FaFolderOpen,
} from "react-icons/fa";

const CustomEmptyState = () => (
  <div className="text-center py-5 my-3">
    <div
      className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
      style={{ width: "64px", height: "64px", backgroundColor: "#f1f5f9", color: "#94a3b8" }}
    >
      <FaFolderOpen size={28} />
    </div>
    <h6 className="fw-semibold text-dark mb-1">No Records Found</h6>
    <p className="text-muted small mb-0">There are currently no items to display in this list.</p>
  </div>
);

const Data_Table = ({ tableData = [], title }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [value, setValue] = useState("");

  const [sortColumn, setSortColumn] = useState(""); // Track sorting column
  const [sortDirection, setSortDirection] = useState("asc");

  const [visibile, setVisible] = useState(false);
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Source, setSource] = useState(true);
  const [Type, setType] = useState(true);

  useEffect(() => {
    if (tableData.length) {
      setItemsPerPage(4);
    }
  }, [tableData]);

  const handleSort = (columnName) => {
    const columnKey = {
      Subject: "subject",
      Status: "status",
      "Due Date": "duedate",
      Priority: "priority",
      Assigned: "assigned",
      Created: "createdBy",
    }[columnName];

    setSortColumn(columnKey);
    setSortDirection((prevDirection) =>
      prevDirection === "asc" ? "desc" : "asc",
    );
  };

  const columns = [
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
      omit: !Subject,
      grow: 2,
      minWidth: "220px",
      cell: (row) => (
        <span
          className="text-truncate font-weight-bold text-dark"
          title={row.subject}
          style={{
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
        >
          {row.subject}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      omit: !Status,
      minWidth: "120px",
      grow: 1,
      cell: (row) => {
        const status = row.status || "Draft";
        const statusLower = status.toLowerCase();
        let badgeClass = "bg-warning-subtle text-warning border-warning-subtle";

        if (statusLower.includes("draft")) {
          badgeClass = "bg-secondary-subtle text-secondary border-secondary-subtle";
        } else if (
          statusLower.includes("open") ||
          statusLower.includes("paid") ||
          statusLower.includes("completed") ||
          statusLower.includes("accepted")
        ) {
          badgeClass = "bg-success-subtle text-success border-success-subtle";
        } else if (
          statusLower.includes("pending") ||
          statusLower.includes("progress") ||
          statusLower.includes("sent")
        ) {
          badgeClass = "bg-warning-subtle text-warning border-warning-subtle";
        } else if (
          statusLower.includes("overdue") ||
          statusLower.includes("cancelled") ||
          statusLower.includes("declined")
        ) {
          badgeClass = "bg-danger-subtle text-danger border-danger-subtle";
        }

        return (
          <span
            className={`badge border px-2 py-1 ${badgeClass}`}
            style={{ fontSize: "11px", borderRadius: "6px", fontWeight: "600", whiteSpace: "nowrap" }}
          >
            {status}
          </span>
        );
      },
    },
    {
      name: "Due Date",
      selector: (row) => row.duedate,
      sortable: true,
      omit: !Duedate,
      minWidth: "120px",
    },
    {
      name: "Priority",
      selector: (row) => row.priority,
      sortable: true,
      omit: !Priority,
      minWidth: "100px",
    },
    {
      name: "Source",
      selector: (row) => row.source || "N/A",
      sortable: true,
      omit: !Source,
      minWidth: "100px",
    },
    {
      name: "Assigned",
      selector: (row) => row.assigned,
      sortable: true,
      omit: !Assigned,
      minWidth: "140px",
      cell: (row) => (
        <span
          className="text-truncate"
          title={row.assigned}
          style={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {row.assigned}
        </span>
      ),
    },
    {
      name: "Created",
      selector: (row) => row.createdBy,
      sortable: true,
      omit: !Type,
      minWidth: "120px",
    },
  ];

  // Filter and sort the data based on the selected column and direction
  const extractNumber = (text) => {
    const match = text.match(/\d+/); // Extract number from string
    return match ? parseInt(match[0], 10) : 0; // Convert to integer
  };

  const filteredData = tableData
    .filter((ele) =>
      value === ""
        ? true
        : Object.values(ele).some((val) =>
            val?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;

      let aValue = a?.[sortColumn]?.toString().toLowerCase() || "";
      let bValue = b?.[sortColumn]?.toString().toLowerCase() || "";

      if (sortColumn === "subject") {
        // Extract numeric part for sorting
        aValue = extractNumber(aValue);
        bValue = extractNumber(bValue);
      }

      return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
    });

  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const formattedData = JSON.stringify(tableData, null, 2);
    copy(formattedData);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const convertToJson = () => {
    const csv = Papa.unparse(tableData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `data.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const convertToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `data.xlsx`);
  };

  const convertToPdf = () => {
    const doc = new jsPDF();
    const jsonString = JSON.stringify(tableData, null, 2);
    doc.text(jsonString, 10, 10);
    doc.save(`data.pdf`);
  };

  const handlePrint = () => {
    const table = document.createElement("table");
    table.style.borderCollapse = "collapse";
    const tableBody = document.createElement("tbody");
    const headerRow = tableBody.insertRow();
    table.appendChild(tableBody);

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
        <head>
            <title>Print Table</title>
        </head>
        <body>
            ${table.outerHTML}
        </body>
        </html>
    `);

    printWindow.document.close();
    printWindow.print();
  };
  const handleDrop = () => {
    setVisible(!visibile);
  };

  const handleID = () => {
    setId(!Id);
    setVisible(true);
  };
  const handleSubject = () => {
    setSubject(!Subject);
    setVisible(true);
  };
  const handleStatus = () => {
    setStatus(!Status);
    setVisible(true);
  };
  const handlePriority = () => {
    setPriority(!Priority);
    setVisible(true);
  };
  const handleSource = () => {
    setSource(!Source);
    setVisible(true);
  };
  const handleAssigned = () => {
    setAssigned(!Assigned);
    setVisible(true);
  };
  const handleType = () => {
    setType(!Type);
    setVisible(true);
  };
  const handleDuedate = () => {
    setDuedate(!Duedate);
    setVisible(true);
  };
  return (
    <div className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden">
      {/* Header */}
      <div className="card-header bg-white py-3 border-bottom d-flex align-items-center justify-content-between">
        <h5 className="card-title mb-0 fw-bold text-dark fs-6 d-flex align-items-center gap-2">
          <span className="rounded-2 p-1 px-2 bg-slate-100 text-secondary">
            <FaFolderOpen size={15} />
          </span>
          {title}
        </h5>
        <span className="badge bg-slate-100 text-slate-600 border px-2.5 py-1 rounded-pill fw-normal" style={{ fontSize: "0.75rem" }}>
          {filteredData.length} records
        </span>
      </div>

      <div class="card-body">
        <div id="example1_wrapper" class="dataTables_wrapper dt-bootstrap4">
          <div
            className="d-flex justify-content-between my-3z my-3z1"
            style={{
              "padding-bottom": "1rem",
            }}
          >
            <div className="bg-secondary mx-2 rounded Action Action1 d-flex">
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item"
                onClick={handleCopyClick}
              >
                {copied ? "Copied!" : "Copy"}
              </label>
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item"
                onClick={convertToJson}
              >
                CSV
              </label>
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item"
                onClick={convertToExcel}
              >
                Excel
              </label>
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item"
                onClick={convertToPdf}
              >
                PDF
              </label>
              <label
                htmlFor=""
                className="px-2 py-1 m-0 item"
                onClick={handlePrint}
              >
                Print
              </label>
              <OutsideClickHandler
                onOutsideClick={() => {
                  setVisible(false);
                }}
              >
                <div className="dropdown">
                  <label
                    htmlFor=""
                    className="px-2 py-1 m-0 item btn  dropdown-toggle"
                    onClick={handleDrop}
                    data-toggle="dropdown"
                    style={{
                      color: "#fff",
                    }}
                  >
                    Column Visibility
                  </label>

                  {/* Custom dropdown for column visibility */}
                  <div
                    className={`dropdown-menu ${
                      visibile ? "show" : ""
                    } dropdown-menu-right`}
                  >
                    {/* Add your dropdown content here */}
                    <div
                      className="menuItem"
                      onClick={handleID}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Id ? "#007bff" : "",
                        color: Id ? "white" : "",
                      }}
                    >
                      ID
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleSubject}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Subject ? "#007bff" : "",
                        color: Subject ? "white" : "",
                      }}
                    >
                      Subject
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleStatus}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Status ? "#007bff" : "",
                        color: Status ? "white" : "",
                      }}
                    >
                      Status
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleDuedate}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Duedate ? "#007bff" : "",
                        color: Duedate ? "white" : "",
                      }}
                    >
                      Due Date
                    </div>
                    <div
                      className="menuItem"
                      onClick={handlePriority}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Priority ? "#007bff" : "",
                        color: Priority ? "white" : "",
                      }}
                    >
                      Priority
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleAssigned}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Assigned ? "#007bff" : "",
                        color: Assigned ? "white" : "",
                      }}
                    >
                      Assigned
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleSource}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Source ? "#007bff" : "",
                        color: Source ? "white" : "",
                      }}
                    >
                      Source
                    </div>
                    <div
                      className="menuItem"
                      onClick={handleType}
                      style={{
                        width: "200px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "5px",
                        marginRight: "5px",
                        borderRadius: "1px",
                        backgroundColor: Type ? "#007bff" : "",
                        color: Type ? "white" : "",
                      }}
                    >
                      Created
                    </div>
                    {/* Add more dropdown items as needed */}
                  </div>
                </div>
              </OutsideClickHandler>
            </div>
            <div className="Next2 Next5">
              <label htmlFor="" className="p-0 mx-1 my-0">
                Search :
              </label>
              <input
                type="text"
                className="Next3"
                onChange={(e) => setValue(e.target.value)}
                // Add onChange event to handle search
                value={value}
                style={{
                  "border-radius": "unset",
                  border: "1px solid ",
                  borderRadius: "0",
                }}
              />
            </div>
          </div>

          <div className="table-container">
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Data_Table;
